var map = {
	"./1.svg": 37199,
	"./2.svg": 34876,
	"./3.svg": 63421,
	"./4.svg": 29490,
	"./5.svg": 32803,
	"./6.svg": 27056,
	"./7.svg": 18177,
	"./8.svg": 60758,
	"./9.svg": 23975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7078;